export const CONNECT_APP_EXPERIENCE_ID = 'viewVersionDetailsConnectAppExtension';
